import { Component, OnInit } from '@angular/core';
import { tr } from 'date-fns/locale';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-confirm-exam-schedule-restart',
  templateUrl: './confirm-exam-schedule-restart.component.html',
  styleUrls: ['./confirm-exam-schedule-restart.component.scss']
})
export class ConfirmExamScheduleRestartComponent implements OnInit {

  notifyCandidate: boolean = true;
  constructor(private examSchService: ExamScheduleService, private examService: ExamService, private snackBar: SnackbarService, private popoverRef: PopoverRef<ConfirmExamScheduleRestartComponent>,) { }

  ngOnInit(): void {
  }


  async restartExam() {
    try {
      let data = {
        Ids: this.examSchService.selectedIds.map(x => parseInt(x)),
        NotifyCandidate: this.notifyCandidate,
        SelectAll: this.examSchService.selectAll,
        ExaminationID: this.examService.selectedExamIds[0],
      }
      await this.examSchService.restartExaminationSchedules(data);
      this.snackBar.success('Examination Schedule(s) Restarted Successfully!');
      this.examSchService.reloadGrid.next(true);
      this.close();
    } catch (error) {
      this.snackBar.error('Failed to restart Examination Schedule(s). Please try again later.');
      console.log(error);
    }
  }

  close() {
    this.popoverRef.close();
  }
}
